import { useCallback, useEffect } from 'react'

import { useMe } from '@shared/providers/src/MeProvider'

import { sendNewGTMEvent } from '@utils/GTM'

export default function useNewGTMEvent() {
  const me = useMe()

  return useCallback(
    (event, params = {}) => {
      const userData = {
        user_id: me.id,
        first_name: me.firstName,
        last_name: me.lastName,
        email: me.email,
        phone: me.phone,
        state: me.homeAddress?.state,
        zip: me.homeAddress?.zip,
      }

      return sendNewGTMEvent(event, { ...userData, ...params })
    },
    [me]
  )
}

export const useNewGTMPageLoad = (page, { enabled = true } = {}) => {
  const send = useNewGTMEvent()

  useEffect(() => {
    if (enabled) send('page_load', { page })
  }, [page, enabled, send])
}
